import single from './logo_doclenz_single.png'
import horizontalLight from './logo_doclenz_texto_direita_fundo_claro.png'
import horizontalDark from './logo_doclenz_texto_direita_fundo_escuro.png'
import stackedLight from './logo_doclenz_texto_embaixo_tema_claro.png'
import stackedDark from './logo_doclenz_texto_embaixo_tema_escuro.png'

/**
 * As variantes da marca, num lugar só.
 *
 * Cada uma existe para um fundo específico: as versões "escuro" têm o texto em branco e só
 * funcionam sobre fundo escuro; as "claro" têm o texto em azul-marinho e somem num fundo escuro.
 * Escolher pela cor do fundo, não pelo tema da aplicação — a barra lateral do console é azul
 * escura mesmo no tema claro, e ali vale a variante escura.
 */
export const logo = {
  /** Só a marca, sem texto. Para espaços apertados: barra recolhida, favicon. */
  mark: single,
  /** Texto à direita. Para faixas horizontais, como o cabeçalho da barra lateral. */
  horizontal: { onLight: horizontalLight, onDark: horizontalDark },
  /** Texto embaixo. Para blocos centrados, como a tela de login. */
  stacked: { onLight: stackedLight, onDark: stackedDark },
} as const

/** A variante horizontal adequada ao fundo. */
export function horizontalFor(background: 'light' | 'dark'): string {
  return background === 'dark' ? logo.horizontal.onDark : logo.horizontal.onLight
}

/** A variante empilhada adequada ao fundo. */
export function stackedFor(background: 'light' | 'dark'): string {
  return background === 'dark' ? logo.stacked.onDark : logo.stacked.onLight
}
